import type { ThemeClasses } from "../types";
import type { TFunction } from "i18next";
import PaginationControls from "../../../../../../components/base/PaginationControls";

interface TripPaginationProps {
  themeClasses: ThemeClasses;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  t: TFunction;
}

export function TripPagination({
  currentPage,
  totalPages,
  onPageChange,
}: TripPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
